import React, { useRef, useEffect } from 'react';
import classes from "./LoadingPost.css";
import LetterIcon from "../../UI/LetterIcon/LetterIcon";
import LoadingBar from "./LoadingBar/LoadingBar";

const LoadingPost = (props) => {
    let loadingDiv = useRef();
    useEffect(() => {
        document.onscroll = (event) => {
            let top = loadingDiv.current.getBoundingClientRect().top;
            let offset = 0;
            if ((top + offset) >= 0 && (top - offset) <= window.innerHeight) {
                props.nextPosts();
            }
        }
    }, []);
    return (
        <div ref={loadingDiv} className={classes.LoadingPost} >
            <div className={classes.Header}>
                <LetterIcon letter="....." color="#ccc" />
                <span><LoadingBar width="50vw" height="2rem" /></span>
            </div>
            <div className={classes.Content}>
                <div className={classes.PostTitle}><LoadingBar width="100%" height="2rem" /></div>
                <div className={classes.PostContent}><LoadingBar width="100%" height="200px" /></div>
            </div>


        </div>
    );
}

export default LoadingPost;